import { IReceiptData } from "./ApiCalls";
import { GlobalConstants } from "./GlobalConstants";
import { GlobalPermissions } from "./GlobalPermissions";
import { GlobalVariables } from "./GlobalVariables";
import { ReduxUpdater } from "./redux/ReduxUpdater";

export const FilterCategories = (receipt: IReceiptData, doFilter: boolean) => {
    const permissionString = `${receipt.message_id.startsWith('RCPT') ? 'R' : ''}${receipt.receipt_type === 'petty_cash' ? '$' : ''}${ReduxUpdater.authenticatedUser?.user_role}`;
    // console.log('CHECK:', permissionString);
    if (!GlobalPermissions.UX.EXPENSES.ReviewAndConfirm.LimitedCategories.includes(permissionString)) {
        return GlobalConstants.CreateReceiptCategories;
    }
    
    return GlobalVariables.accountingCategoriesFiltered(receipt.user_description, doFilter);
};